import React, { memo } from "react";
import { useI18n } from "./integrations/formatjs/I18nContext";
import { shallowEqual } from "./utils/shallowEqual";
const I18nDate = ({ domain, value, dateStyle, timeZone, }) => {
    const intl = useI18n({ domain });
    return React.createElement(React.Fragment, null, intl.formatDate(value, { dateStyle, timeZone }));
};
const MemoizedI18nDate = memo(I18nDate, shallowEqual);
export { MemoizedI18nDate as I18nDate };
